export const imageDefaults = {
  workspace: 'Admin',
  disk: 'public',
  format: 'jpg',
  folder: '/images/admin/avatar',
  category: 'avatar',
  thumb: 250,
  alt: 'Imagen de administrador',
  isSave: 'false',
  isOverwrite: 'false',
};
